import { formatNumberMix } from '@/utils'
export const setOverviewData = (data, params, setting) => {
  let arr = []
  // let str = ''
  // switch (params.adSource) {
  //   case 0:
  //     str = 'Google、Facebook'
  //     break
  //   case 1:
  //     str = 'Facebook'
  //     break
  //   case 2:
  //     str = 'Google'
  //     break
  //   default:
  //     break
  // }
  let obj = {
    adSpend: {
      title: window.$t('ad-analysis::广告费用'),
      count: data && data.adSpend ? formatNumberMix(data.adSpend, 2, ',') : '--',
      lastCount: data && data.lastAdSpend ? formatNumberMix(data.lastAdSpend, 2, ',') : '--',
      down: data && data.adSpendRatio ? data.adSpendRatio < 0 : false,
      statisticsDays: data && data.countDays,
      rate: data && data.adSpendRatio ? formatNumberMix(data.adSpendRatio, 2, '', '') : '--',
      tooltip: `${window.$t('ad-analysis::广告费用tooltip')}`
    },
    conversionsValue: {
      title: window.$t('ad-analysis::广告转化价值'),
      count: data && data.conversionsValue ? formatNumberMix(data.conversionsValue, 2, ',') : '--',
      lastCount: data && data.lastConversionsValue ? formatNumberMix(data.lastConversionsValue, 2, ',') : '--',
      down: data && data.conversionsValueRatio ? data.conversionsValueRatio < 0 : false,
      statisticsDays: data && data.countDays,
      rate: data && data.conversionsValueRatio ? formatNumberMix(data.conversionsValueRatio, 2, '', '') : '--',
      tooltip: `${window.$t('ad-analysis::广告转化价值tooltip')}`
    },
    payAmount: {
      title: window.$t('ad-analysis::销售金额'),
      count: data && data.payAmount ? formatNumberMix(data.payAmount, 2, ',') : '--',
      lastCount: data && data.lastPayAmount ? formatNumberMix(data.lastPayAmount, 2, ',') : '--',
      down: data && data.payAmountRatio ? data.payAmountRatio < 0 : false,
      statisticsDays: data && data.countDays,
      rate: data && data.payAmountRatio ? formatNumberMix(data.payAmountRatio, 2, '', '') : '--',
      tooltip: `${window.$t('ad-analysis::销售金额tooltip')}`
    },
    roi: {
      title: 'ROI',
      count: data && data.roi ? formatNumberMix(data.roi, 2, ',') : '--',
      lastCount: data && data.lastRoi ? formatNumberMix(data.lastRoi, 2, ',') : '--',
      down: data && data.roiRatio ? data.roiRatio < 0 : false,
      statisticsDays: data && data.countDays,
      rate: data && data.roiRatio ? formatNumberMix(data.roiRatio, 2, '', '') : '--',
      tooltip: `${window.$t('ad-analysis::roitooltip')}`
    },
    empressions: {
      title: window.$t('ad-analysis::展示量'),
      count: data && data.empressions ? formatNumberMix(data.empressions, '', ',') : '--',
      lastCount: data && data.lastEmpressions ? formatNumberMix(data.lastEmpressions, 2, ',') : '--',
      down: data && data.empressionsRatio ? data.empressionsRatio < 0 : false,
      statisticsDays: data && data.countDays,
      rate: data && data.empressionsRatio ? formatNumberMix(data.empressionsRatio, 2, '', '') : '--',
      tooltip: `${window.$t('ad-analysis::展示量tooltip')}`
    },
    clicks: {
      title: window.$t('ad-analysis::点击量'),
      count: data && data.clicks ? formatNumberMix(data.clicks, '', ',') : '--',
      lastCount: data && data.lastClicks ? formatNumberMix(data.lastClicks, 2, ',') : '--',
      down: data && data.clicksRatio ? data.clicksRatio < 0 : false,
      statisticsDays: data && data.countDays,
      rate: data && data.clicksRatio ? formatNumberMix(data.clicksRatio, 2, '', '') : '--',
      tooltip: `${window.$t('ad-analysis::点击量tooltip')}`
    },
    transFee: {
      title: window.$t('ad-analysis::平均转化费用'),
      count: data && data.transFee ? formatNumberMix(data.transFee, 2, ',') : '--',
      lastCount: data && data.lastTransFee ? formatNumberMix(data.lastTransFee, 2, ',') : '--',
      down: data && data.transFeeRatio ? data.transFeeRatio < 0 : false,
      statisticsDays: data && data.countDays,
      rate: data && data.transFeeRatio ? formatNumberMix(data.transFeeRatio, 2, '', '') : '--',
      tooltip: `${window.$t('ad-analysis::平均转化费用tooltip')}`
    },
    orderNum: {
      title: window.$t('ad-analysis::下单量'),
      count: data && data.orderNum ? formatNumberMix(data.orderNum, '', ',') : '--',
      lastCount: data && data.lastOrderNum ? formatNumberMix(data.lastOrderNum, 2, ',') : '--',
      down: data && data.orderNumRatio ? data.orderNumRatio < 0 : false,
      statisticsDays: data && data.countDays,
      rate: data && data.orderNumRatio ? formatNumberMix(data.orderNumRatio, 2, '', '') : '--',
      tooltip: `${window.$t('ad-analysis::下单量tooltip')}`
    },
    customerPrice: {
      title: window.$t('ad-analysis::客单价'),
      count: data && data.customerPrice ? formatNumberMix(data.customerPrice, 2, ',') : '--',
      lastCount: data && data.lastCustomerPrice ? formatNumberMix(data.lastCustomerPrice, 2, ',') : '--',
      down: data && data.customerPriceRatio ? data.customerPriceRatio < 0 : false,
      statisticsDays: data && data.countDays,
      rate: data && data.customerPriceRatio ? formatNumberMix(data.customerPriceRatio, 2, '', '') : '--',

      tooltip: `${window.$t('ad-analysis::客单价tooltip')}`
    },
    clickRate: {
      title: window.$t('ad-analysis::点击率'),
      count: data && data.clickRate ? formatNumberMix(data.clickRate, 2, ',', '%') : '--',
      lastCount: data && data.lastClickRate ? formatNumberMix(data.lastClickRate, 2, ',') : '--',
      down: data && data.clickRateRatio ? data.clickRateRatio < 0 : false,
      statisticsDays: data && data.countDays,
      rate: data && data.clickRateRatio ? formatNumberMix(data.clickRateRatio, 2, '', '') : '--',
      tooltip: `${window.$t('ad-analysis::点击率tooltip')}`
    },
    cpm: {
      title: 'CPM',
      count: data && data.cpm ? formatNumberMix(data.cpm, 2, ',') : '--',
      lastCount: data && data.lastCpm ? formatNumberMix(data.lastCpm, 2, ',') : '--',
      down: data && data.cpmRatio ? data.cpmRatio < 0 : false,
      statisticsDays: data && data.countDays,
      rate: data && data.cpmRatio ? formatNumberMix(data.cpmRatio, 2, '', '') : '--',
      tooltip: `${window.$t('ad-analysis::cpmtooltip')}`
    },
    cpc: {
      title: 'CPC',
      count: data && data.cpc ? formatNumberMix(data.cpc, 2, ',') : '--',
      lastCount: data && data.lastCpc ? formatNumberMix(data.lastCpc, 2, ',') : '--',
      down: data && data.cpcRatio ? data.cpcRatio < 0 : false,
      statisticsDays: data && data.countDays,
      rate: data && data.cpcRatio ? formatNumberMix(data.cpcRatio, 2, '', '') : '--',
      tooltip: `${window.$t('ad-analysis::cpctooltip')}`
    },
    payTransRate: {
      title: window.$t('ad-analysis::支付转化率'),
      count: data && data.payTransRate ? formatNumberMix(data.payTransRate, 2, ',', '%') : '--',
      lastCount: data && data.lastPayTransRate ? formatNumberMix(data.lastPayTransRate, 2, ',') : '--',
      down: data && data.payTransRateRatio ? data.payTransRateRatio < 0 : false,
      statisticsDays: data && data.countDays,
      rate: data && data.payTransRateRatio ? formatNumberMix(data.payTransRateRatio, 2, '', '') : '--',
      tooltip: `${window.$t('ad-analysis::支付转化率tooltip')}`
    },
    initiateCheckout: {
      title: window.$t('ad-analysis::成交量'),
      count: data && data.initiateCheckout ? formatNumberMix(data.initiateCheckout, '', ',') : '--',
      lastCount: data && data.lastInitiateCheckout ? formatNumberMix(data.lastInitiateCheckout, 2, ',') : '--',
      down: data && data.initiateCheckoutRatio ? data.initiateCheckoutRatio < 0 : false,
      statisticsDays: data && data.countDays,
      rate: data && data.initiateCheckoutRatio ? formatNumberMix(data.initiateCheckoutRatio, 2, '', '') : '--',
      tooltip: `${window.$t('ad-analysis::成交量tooltip')}`
    },
    addToCart: {
      title: window.$t('ad-analysis::加购量'),
      count: data && data.addToCart ? formatNumberMix(data.addToCart, '', ',') : '--',
      lastCount: data && data.lastAddToCart ? formatNumberMix(data.lastAddToCart, 2, ',') : '--',
      down: data && data.addToCartRatio ? data.addToCartRatio < 0 : false,
      statisticsDays: data && data.countDays,
      rate: data && data.addToCartRatio ? formatNumberMix(data.addToCartRatio, 2, '', '') : '--',
      tooltip: `${window.$t('ad-analysis::加购量tooltip')}`
    },
    addToCartValue: {
      title: window.$t('ad-analysis::加购金额'),
      count: data && data.addToCartValue ? formatNumberMix(data.addToCartValue, 2, ',') : '--',
      lastCount: data && data.lastAddToCartValue ? formatNumberMix(data.lastAddToCartValue, 2, ',') : '--',
      down: data && data.addToCartValueRatio ? data.addToCartValueRatio < 0 : false,
      statisticsDays: data && data.countDays,
      rate: data && data.addToCartValueRatio ? formatNumberMix(data.addToCartValueRatio, 2, '', '') : '--',
      tooltip: `${window.$t('ad-analysis::加购金额tooltip')}`
    },
    payRate: {
      title: window.$t('ad-analysis::发起结账率'),
      count: data && data.payRate ? formatNumberMix(data.payRate, 2, ',', '%') : '--',
      lastCount: data && data.lastPayRate ? formatNumberMix(data.lastPayRate, 2, ',') : '--',
      down: data && data.payRateRatio ? data.payRateRatio < 0 : false,
      statisticsDays: data && data.countDays,
      rate: data && data.payRateRatio ? formatNumberMix(data.payRateRatio, 2, '', '') : '--',
      tooltip: `${window.$t('ad-analysis::发起结账率tooltip')}`
    },
  }

  for (let i = 0; i < setting.length; i++) {
    if (setting[i].actived) {
      arr.push(obj[setting[i].key])
    }
  }
  return arr
}
export const columns = (adSource) => {
  let list = [
    {
      label: window.$t('ad-analysis::date'),
      prop: 'date',
      minWidth: 130,
      active: true
    },
    {
      label: window.$t('ad-analysis::adAccount'),
      prop: 'adAccountName',
      minWidth: 200,
      slotHeaderName: 'tableSeriesHeader',
      active: true
    },
    {
      label: window.$t('ad-analysis::table_shopName'),
      prop: 'shopName',
      minWidth: 180,
      active: true
    },
    {
      label: window.$t('ad-analysis::广告转化价值'),
      prop: 'paymentAmount',
      minWidth: 150,
      active: true
    },
    {
      label: window.$t('ad-analysis::广告花费'),
      prop: 'adSpend',
      minWidth: 150,
      active: true
    },
    {
      label: 'ROI',
      prop: 'roi',
      minWidth: 150,
      active: true
    },
    {
      label: window.$t('ad-analysis::展示量'),
      prop: 'impressions',
      minWidth: 150,
      active: true
    },
    {
      label: window.$t('ad-analysis::table_clickNum'),
      prop: 'clickCnt',
      minWidth: 150,
      active: true
    },
    {
      label: window.$t('ad-analysis::点击率(CTR)'),
      prop: 'clickRate',
      minWidth: 150,
      active: true
    },
    {
      label: window.$t('ad-analysis::成交量'),
      prop: 'paymentCnt',
      minWidth: 150,
      active: false
    },
    {
      label: window.$t('ad-analysis::客单价'),
      prop: 'customerPrice',
      minWidth: 150,
      active: true
    },
    {
      label: window.$t('ad-analysis::支付转化率(CVR)'),
      prop: 'payTransRate',
      minWidth: 170,
      active: true
    },
    {
      label: window.$t('ad-analysis::table_transCost'),
      prop: 'transFeePer',
      minWidth: 150,
      active: true
    },
    {
      label: 'CPC',
      prop: 'cpc',
      minWidth: 150,
      active: true
    },
    {
      label: 'CPM',
      prop: 'cpm',
      minWidth: 150,
      active: true
    },
  ]
  return adSource === 1 ? [...list, ...fbConfig] : list
}
// 固定表头
export const fixTableHeaderList = [
  'date',
  'shopName',
  'paymentAmount',
  'adSpend',
  'roi',
  'adAccountName',
  'adCampaignName',
  'adAdsetName',
  'adName'
]
// Facebook专有表头
export const fbConfig = [
  {
    label: window.$t('ad-analysis::销售金额'),
    prop: 'saleAmount',
    minWidth: 150,
    active: true
  },
  {
    label: window.$t('ad-analysis::加购量'),
    prop: 'addToCart',
    minWidth: 130,
    active: true
  },
  {
    label: window.$t('ad-analysis::加购金额'),
    prop: 'addToCartValue',
    minWidth: 130,
    active: true
  }
]

export const CardKeyList = [
  { key: 'adSpend', label: window.$t('ad-analysis::广告费用'), actived: true },
  { key: 'conversionsValue', label: window.$t('ad-analysis::广告转化价值'), actived: true },
  { key: 'customerPrice', label: window.$t('ad-analysis::客单价'), actived: true },
  { key: 'roi', label: 'ROI', actived: true },
  { key: 'empressions', label: window.$t('ad-analysis::展示量'), actived: true },
  { key: 'clicks', label: window.$t('ad-analysis::点击量'), actived: true },
  { key: 'initiateCheckout', label: window.$t('ad-analysis::成交量'), actived: false },
  { key: 'clickRate', label: window.$t('ad-analysis::点击率'), actived: false },
  { key: 'cpm', label: 'CPM', actived: false },
  { key: 'cpc', label: 'CPC', actived: false },
  { key: 'payTransRate', label: window.$t('ad-analysis::支付转化率'), actived: false },
  { key: 'transFee', label: window.$t('ad-analysis::平均转化费用'), actived: false },
]

export const FbCardKeyList = [
  { key: 'adSpend', label: window.$t('ad-analysis::广告费用'), actived: true },
  { key: 'payAmount', label: window.$t('ad-analysis::销售金额'), actived: true },
  { key: 'conversionsValue', label: window.$t('ad-analysis::广告转化价值'), actived: true },
  { key: 'roi', label: 'ROI', actived: true },
  { key: 'empressions', label: window.$t('ad-analysis::展示量'), actived: true },
  { key: 'clicks', label: window.$t('ad-analysis::点击量'), actived: true },
  { key: 'addToCart', label: window.$t('ad-analysis::加购量'), actived: false },
  { key: 'addToCartValue', label: window.$t('ad-analysis::加购金额'), actived: false },
  { key: 'orderNum', label: window.$t('ad-analysis::下单量'), actived: false },
  { key: 'initiateCheckout', label: window.$t('ad-analysis::成交量'), actived: false },
  { key: 'customerPrice', label: window.$t('ad-analysis::客单价'), actived: false },
  { key: 'clickRate', label: window.$t('ad-analysis::点击率'), actived: false },
  { key: 'cpm', label: 'CPM', actived: false },
  { key: 'cpc', label: 'CPC', actived: false },
  { key: 'payTransRate', label: window.$t('ad-analysis::支付转化率'), actived: false },
  { key: 'payRate', label: window.$t('ad-analysis::发起结账率'), actived: false },
  { key: 'transFee', label: window.$t('ad-analysis::平均转化费用'), actived: false }
]